import type { DiaryEntry, DiaryEntriesListResponse, DiaryEntryResponse } from '../types/diary.types';

const API_BASE = '/api/diary';

export const fetchDiaryEntries = async (order: 'asc' | 'desc' = 'asc'): Promise<DiaryEntry[]> => {
  const response = await fetch(`${API_BASE}/entries?order=${order}`);

  if (!response.ok) {
    throw new Error('Failed to fetch diary entries');
  }

  const json = (await response.json()) as DiaryEntriesListResponse;

  return json.data.map((item) => ({
    id: item.id,
    content: item.attributes.content,
    entry_date: item.attributes.entry_date,
    created_at: item.attributes.created_at,
    updated_at: item.attributes.updated_at,
  }));
};

export const fetchDiaryEntry = async (id: string): Promise<DiaryEntry> => {
  const response = await fetch(`${API_BASE}/entries/${id}`);

  if (!response.ok) {
    throw new Error('Failed to fetch diary entry');
  }

  const json = (await response.json()) as DiaryEntryResponse;

  return {
    id: json.data.id,
    content: json.data.attributes.content,
    entry_date: json.data.attributes.entry_date,
    created_at: json.data.attributes.created_at,
    updated_at: json.data.attributes.updated_at,
  };
};
